// Sezione "Eventi in programma" per la vetrina pubblica di un partner.
// Si nasconde automaticamente se il partner non ha eventi pubblicati.
import React, { useEffect, useState } from 'react';
import { eventsService } from '@/services/events.service';
import { setCategories } from '@/lib/eventsMock';
import { PublicEventCard } from '@/components/public/PublicEventCard';
import { CalendarDays } from 'lucide-react';

export function OwnerEventsSection({ ownerId, className = '' }) {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    if (!ownerId) return;
    let alive = true;
    eventsService.publicByOwner(ownerId)
      .then((data) => {
        if (!alive) return;
        setCategories(data?.categories || []);
        setEvents(Array.isArray(data?.events) ? data.events : []);
      })
      .catch(() => alive && setEvents([]));
    return () => { alive = false; };
  }, [ownerId]);

  if (!events || events.length === 0) return null;

  return (
    <section className={`py-10 sm:py-14 ${className}`} data-testid="owner-events-section">
      <div className="mb-6 flex items-center gap-2">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/10 text-primary"><CalendarDays className="h-5 w-5" /></span>
        <div>
          <h2 className="font-display text-2xl font-bold tracking-tight text-foreground">Eventi in programma</h2>
          <p className="text-sm text-muted-foreground">Gli eventi con biglietteria di questo partner.</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {events.map((e) => <PublicEventCard key={e.id || e.slug} e={e} />)}
      </div>
    </section>
  );
}
